import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} {...props}>
		<g fill='#ee2b7b' data-name='Grupo 18890' transform='translate(3.944 3.944)'>
			<rect
				width={8}
				height={8}
				data-name='Rect\xE1ngulo 85579'
				rx={2}
				transform='translate(.056 .056)'
			/>
			<rect
				width={8}
				height={8}
				data-name='Rect\xE1ngulo 85581'
				rx={2}
				transform='translate(.056 9.056)'
			/>
			<rect
				width={8}
				height={8}
				data-name='Rect\xE1ngulo 85580'
				rx={2}
				transform='translate(9.056 .056)'
			/>
			<rect
				width={8}
				height={8}
				data-name='Rect\xE1ngulo 85582'
				rx={2}
				transform='translate(9.056 9.056)'
			/>
		</g>
		<path fill='none' d='M0 0h24v24H0z' data-name='Rect\xE1ngulo 85587' />
	</svg>
)
export default SvgComponent
